var map = {
	"./pages/login/login-page.module": [
		664,
		0
	],
	"./pages/register/register.module": [
		665,
		3
	],
	"./pages/role-list/role-list.module": [
		666,
		1
	],
	"./pages/user-list/user-list.module": [
		667,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 317;



//////////////////
// WEBPACK FOOTER
// ./src async
// module id = 317
// module chunks = 5